import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import AttendanceListing from 'views/admin/attendance/AttendanceListing'

const Attendance = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <AttendanceListing />
      </Route>
    </Switch>
  )
}

export default Attendance
